import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
let TreeRefServiceImp = class TreeRefServiceImp {
    constructor() {
        this._treeRef = null;
    }
    getTreeRef() {
        if (!this._treeRef) {
            throw new Error('TreeRef is not set');
        }
        return this._treeRef;
    }
    setTreeRef(treeRef) {
        this._treeRef = treeRef;
    }
};
TreeRefServiceImp = __decorate([
    injectable()
], TreeRefServiceImp);
export { TreeRefServiceImp };
